import { DialogSlideRight } from "../../Dialogs/SlideInRightDialog";
import { SelectingExercisesTable } from "../SelectingExercisesTable";
import { ExerciseDataType, ExerciseInterface, ObjectiveInterface } from "../../../interfaces/examInterfaces";
import { SelectExercisesAccordion } from "../SelectExercisesAccordion";
import { useEffect, useState } from "react";
import { fetchExercises } from "../../../firebase/firebaseExamService";
import { Grade } from "../../../types/App";
import { CircularProgress, Stack } from "@mui/material";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import { changeExercises, setNewExercises } from "../Functions/FunctionsManipulateExercises";
import { useSelector } from "react-redux";
import { RootState } from "../../..";
import { useLocation } from "react-router-dom";
import { DEMO_DATA_FIRST_OBJECTIVE, DEMO_DATA_SECOND_OBJECTIVE } from "../DemoData";

const SelectExercisesExamDialog = ({
  open,
  objectiveId,
  grade,
  objective,
  sortedExercises,
  handleCancel,
}: {
  open: boolean;
  objectiveId: string | null;
  grade: Grade;
  objective: ObjectiveInterface | null;
  sortedExercises: ExerciseInterface[];
  handleCancel: () => void;
}) => {
  const [exerciseData, setExerciseData] = useState<ExerciseDataType[] | null>(null);

  const examData = useSelector((state: RootState) => state.examBuilder.main.examData);
  const selectedObjectiveId = useSelector((state: RootState) => state.examBuilder.main.selectedObjectiveId);
  const indexNewExercises = useSelector((state: RootState) => state.examBuilder.manipulateExercises.indexNewExercises);
  const exercisesCopy = useSelector((state: RootState) => state.examBuilder.main.exercisesCopy);
  const newExercises = useSelector((state: RootState) => state.examBuilder.manipulateExercises.newExercises);
  const dialogSelectExercisesOpen = useSelector((state: RootState) => state.dialogs.selectExercisesExamDialog);

  const { pathname } = useLocation();
  const isDemoMode = pathname.startsWith("/demo");

  const subtitle = (
    <>
      <strong>
        {objective?.topic} K{objective?.objectiveIndex}
      </strong>{" "}
      <br />
      {objective?.objective}
    </>
  );

  //Fetch the exercises
  useEffect(() => {
    if (isDemoMode) {
      getDemoData();
    } else {
      fetchAndSetExercises();
    }
  }, [dialogSelectExercisesOpen]);

  useEffect(() => {
    if (dialogSelectExercisesOpen) {
      setNewExercises([]);
    }
  }, [dialogSelectExercisesOpen]);

  const getDemoData = () => {
    const dataToLoad = (objectiveId === '6111') ?   DEMO_DATA_FIRST_OBJECTIVE : DEMO_DATA_SECOND_OBJECTIVE;    
    setExerciseData(dataToLoad)
  };

  const fetchAndSetExercises = async () => {
    if (dialogSelectExercisesOpen && objectiveId) {
      try {
        const fetchedData = await fetchExercises({ grade, objectiveId });
        if (fetchedData) {
          const innerArray = fetchedData.levels;
          setExerciseData(innerArray);          
        } else {
          console.error("No exercises found with ID: ", objectiveId);
          setExerciseData([]);
        }
      } catch (error) {
        console.error("Error fetching exercises:", error);
      }
    }
  };

  const handleChangeExercises = () => {
    if (selectedObjectiveId) {
      changeExercises(newExercises, exercisesCopy, indexNewExercises, selectedObjectiveId, examData);
    }
  };

  return (
    <DialogSlideRight
      open={open}
      handleClose={() => handleCancel()}
      handleConfirm={() => handleChangeExercises()}
      title={`Aufgaben hinzufügen`}
      subtitle={subtitle}
      cancelTitle="Abbrechen"
      confirmTitle="OK"
      icon={NoteAddIcon}
    >
      {exerciseData ? (
        <SelectExercisesAccordion groups={exerciseData} getGroupLabel={(group) => group.name}>
          {(level, index) => (
            <SelectingExercisesTable
              key={index}
              index={index}
              exercises={exerciseData[index].exercises}
              sortedExercises={sortedExercises}
            />
          )}
        </SelectExercisesAccordion>
      ) : (
        <Stack sx={{ display: "flex", alignItems: "center" }}>
          <CircularProgress />
        </Stack>
      )}
    </DialogSlideRight>
  );
};

export default SelectExercisesExamDialog;
